module.exports = __webpack_public_path__ + "img/DiNapoli-icon2.92349270.svg";